// extracted by mini-css-extract-plugin
export default {"container":"t1-z"};